import React from "react";

import { useCountdown } from "../../UI/hooks/UseCountDown";

const displayHLabel = (hour: number) => {
    if (hour == 1) return "hour";
    else return "hours";
};

const ShowCounter = ({ days, hours, minutes, seconds }: any) => {
    console.log(days, hours, minutes, seconds);
    return (
        <div className="show-counter">
            {days > 0 || hours > 0 || (minutes > 0 && "Live in ")}{" "}
            {days > 0 && `${days} days`}{" "}
            {hours > 0 && `${hours} ${displayHLabel(hours)}`}{" "}
            {minutes > 0 && `${minutes} minutes`}{" "}
            {minutes == 0 &&
                days == 0 &&
                hours == 0 &&
                `Live in less than 1 minute`}{" "}
            {minutes < 0 &&
                days < 0 &&
                hours < 0 &&
                minutes < 0 &&
                "Page is currently being published"}
        </div>
    );
};

const CountdownTimer = ({ targetDate }: any) => {
    const [days, hours, minutes, seconds] = useCountdown(targetDate);
    return (
        <ShowCounter
            days={days}
            hours={hours}
            minutes={minutes}
            seconds={seconds}
        />
    );
};

export default CountdownTimer;
